import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { OAuthModule } from 'angular-oauth2-oidc';
import { ConfigsModule } from '../configs';

import { AuthRoutingModule } from './auth-routing.module';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { AuthService } from './services/auth.service';
import { AccessTokenInterceptor } from './services/access-token.interceptor';
import { AuthGuard } from './public-api';



@NgModule({ declarations: [
        AuthCallbackComponent
    ],
    exports: [
        AuthRoutingModule,
        AuthCallbackComponent
    ], imports: [CommonModule,
        AuthRoutingModule,
        OAuthModule.forRoot(),
        ConfigsModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AccessTokenInterceptor, multi: true },
        AuthService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AccessTokenInterceptor, multi: true },
        AuthService,
        AuthGuard
      ]
    };
  }
}
